import RewardCard from './RewardCard.f';

export default RewardCard;
